import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';

@Injectable()
export class ShoppingService {

  private _shoppingCard: BehaviorSubject<{articleNumber: string, qty: number}[]> = new BehaviorSubject([]);
  get shoppingCard(): {articleNumber: string, qty: number}[] {
    return this._shoppingCard.getValue();
  }
  set shoppingCard(shoppingCard: {articleNumber: string, qty: number}[]) {
    this._shoppingCard.next(shoppingCard);
    this.localStorage.set('shopping-card', shoppingCard);
  }

  // tslint:disable-next-line:max-line-length
  private _order: BehaviorSubject<{
    deliverDate: Date,
    shoppingBag: any[],
    references?: string,
    car_type: any,
    brand: any,
    address: string,
    place: string,
    postal_code: string
    id?: number,
    tender?: any,
  }> = new BehaviorSubject({
    deliverDate: null,
    shoppingBag: [],
    references: null,
    car_type: null,
    brand: null,
    address: null,
    place: null,
    postal_code: null,
    tender: null,
  });
  get order(): {
    id?: number,
    deliverDate: Date,
    shoppingBag: any[],
    references?: string,
    car_type: any,
    brand: any,
    address: string,
    place: string,
    postal_code: string,
    tender?: any,
  } {
    return this._order.getValue();
  }
  set order(order: {
    id?: number,
    deliverDate: Date,
    shoppingBag: any[],
    references?: string,
    car_type: any,
    brand: any,
    address: string,
    place: string,
    postal_code: string,
    tender?: any,
  }) {
    this._order.next(order);
    this.localStorage.set('order', order);
  }

  constructor(private localStorage: LocalStorageService) { }

  public Load() {
    const localShoppingBag: {articleNumber: string, qty: number}[] = this.localStorage.get('shopping-card');

    if (localShoppingBag === null || !Array.isArray(localShoppingBag)) {
      this.localStorage.set('shopping-card', []);
      this._shoppingCard.next([]);
    } else {
      this._shoppingCard.next(localShoppingBag);
    }

    const order: {
      deliverDate: null,
      shoppingBag: [],
      references: null,
      car_type: null,
      brand: null,
      address: null,
      place: null,
      postal_code: null
    } = this.localStorage.get('order');

    if (order === null) {
      this.localStorage.set('order', {
        deliverDate: null,
        shoppingBag: [],
        references: null,
        car_type: null,
        brand: null,
        address: null,
        place: null,
        postal_code: null
      });
      this._order.next({
        deliverDate: null,
        shoppingBag: [],
        references: null,
        car_type: null,
        brand: null,
        address: null,
        place: null,
        postal_code: null
      });
    } else {
      this._order.next(order);
    }
  }

  public clear() {
    this.localStorage.set('shopping-card', []);
    this._shoppingCard.next([]);
  }

  public clearOrder() {
    this.localStorage.set('order', {
      deliverDate: null,
      shoppingBag: [],
      references: null,
      car_type: null,
      brand: null,
      address: null,
      place: null,
      postal_code: null
    });
    this._order.next({
      deliverDate: null,
      shoppingBag: [],
      references: null,
      car_type: null,
      brand: null,
      address: null,
      place: null,
      postal_code: null
    });
  }
}
